var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.217 3.02326L12.217 1.02326C12.074 0.992248 11.926 0.992248 11.783 1.02326L2.783 3.02326C2.56077 3.07266 2.36205 3.19641 2.21968 3.37405C2.07731 3.5517 1.99981 3.7726 2 4.00026V14.0003C2 16.6524 3.05357 19.196 4.92893 21.0713C6.8043 22.9467 9.34784 24.0003 12 24.0003C14.6522 24.0003 17.1957 22.9467 19.0711 21.0713C20.9464 19.196 22 16.6524 22 14.0003V4.00026C22.0002 3.7726 21.9227 3.5517 21.7803 3.37405C21.638 3.19641 21.4392 3.07266 21.217 3.02326ZM17 17.0003C17 17.2655 16.8946 17.5198 16.7071 17.7074C16.5196 17.8949 16.2652 18.0003 16 18.0003H8C7.73478 18.0003 7.48043 17.8949 7.29289 17.7074C7.10536 17.5198 7 17.2655 7 17.0003V12.0003C7 11.735 7.10536 11.4807 7.29289 11.2931C7.48043 11.1056 7.73478 11.0003 8 11.0003H9V9.00026C9 8.20461 9.31607 7.44155 9.87868 6.87894C10.4413 6.31633 11.2044 6.00026 12 6.00026C12.7956 6.00026 13.5587 6.31633 14.1213 6.87894C14.6839 7.44155 15 8.20461 15 9.00026V11.0003H16C16.2652 11.0003 16.5196 11.1056 16.7071 11.2931C16.8946 11.4807 17 11.735 17 12.0003V17.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9V11H13V9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.2d5f33775330c5173cc8fb03bb94ae6d.svg";
export { ForwardRef as ReactComponent };